export const testimonials = [
  {
    name: "Dr. Sofía Ramírez",
    role: "General Dentist · Mexico",
    topic: "Assessment",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/c0872edb-9f9a-4d4a-8f6d-125ff54d5148.jpg",
    headline: "A clearer way to organize early orthodontic assessment.",
    quote:
      "What I value most is having the main assessment considerations organized in one place. Reviewing dental development, occlusion, and treatment indications through a consistent framework makes the material genuinely useful for structured learning.",
  },
  {
    name: "Dr. Andrés Medina",
    role: "Dental Surgeon · Colombia",
    topic: "Mixed Dentition",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/0d75c4bf-7671-4ed0-98bf-81eb34274040.jpg",
    headline: "The visual development references are exactly the kind of material I look for.",
    quote:
      "Mixed dentition involves several developmental changes that need to be understood together. The visual atlas is particularly useful for reviewing these concepts.",
  },
  {
    name: "Dr. Lucía Fernández",
    role: "Orthodontist · Argentina",
    topic: "Clinical Reasoning",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/db691651-3f30-4680-9789-31059f110dd4.jpg",
    headline: "I like the emphasis on knowing when not to intervene.",
    quote:
      "Early orthodontic education should involve more than learning about appliances. Understanding treatment indications, limitations, observation, and referral is essential.",
  },
  {
    name: "Dr. Julián Restrepo",
    role: "Dentist · Chile",
    topic: "Phase I Planning",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/21738627-9de6-4c9e-b8bd-f75fd84a5c07.jpg",
    headline: "A practical structure for reviewing treatment-planning principles.",
    quote:
      "Having educational worksheets that connect clinical findings, treatment objectives, and developmental considerations makes case-based learning far more organized.",
  },
  {
    name: "Dr. Elena Navarro",
    role: "Pediatric Dentist · Spain",
    topic: "Case Organization",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/2b42f5b3-3bd5-4957-b15a-b9a68b0fbef8.jpg",
    headline: "More than a collection of disconnected orthodontic topics.",
    quote:
      "The most interesting aspect is the connection between assessment, growth, decision-making, and monitoring. That structure makes it easier to review how different orthodontic concepts relate to one another.",
  },
  {
    name: "Dr. Mateo Vargas",
    role: "Orthodontist · Peru",
    topic: "Decision Pathways",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/c7576085-c0b8-4cb2-a2c0-e5938c0abddd.jpg",
    headline: "The decision pathways changed how I review my pediatric cases.",
    quote:
      "I used to jump straight to thinking about appliances. Working through the pathways first helps me separate what needs monitoring from what needs action — and explain that difference more clearly to parents.",
  },
];
